import React from 'react'

export default function Message() {
  return (
    <main className="main-wrapper login-page">
      <div className="container-login">
        <form className="box-login">
          <h5 className="mb-4">Merci de suivre le lien que nous venons de vous envoyer par email</h5>
        </form>
      </div>
    </main>
  )
}
